module.exports = __webpack_public_path__ + "img/unrevealed2.cc5412e1.svg";